import { useCallback, useState } from "react";
import type { TablePaginationConfig } from "antd/es/table";

/** Состояние одной таблицы: текущая страница и её размер. */
export function usePaginationState(defaultPageSize: number) {
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: defaultPageSize,
  });

  /** Смена размера страницы возвращает к первой — иначе можно уехать за последнюю. */
  const handlePageChange = useCallback((nextPage: number, nextSize: number) => {
    setPagination((prev) => ({
      current: nextSize !== prev.pageSize ? 1 : nextPage,
      pageSize: nextSize,
    }));
  }, []);

  const goToFirstPage = useCallback(
    () => setPagination((prev) => ({ ...prev, current: 1 })),
    [],
  );

  const reset = useCallback(
    () => setPagination({ current: 1, pageSize: defaultPageSize }),
    [defaultPageSize],
  );

  return { pagination, handlePageChange, goToFirstPage, reset };
}
